import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  max-width: 100vw;
`

export const SideBarWrapper = styled.div`
  flex-shrink: 0;
  background: #5c6bc0;
`

export const NextRound = styled.div`
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 1.2em;
`

export const ScoreWrapper = styled.div`
  overflow: auto;
`

export const Scores = styled.div`
  display: inline-block;
`
